import { useEffect, useState } from "react";
import { useApiClient } from "../../../hooks/useApiClient";
import { getLoggedUser } from "../../../services/userService";
import { ILoggedUser } from "../interfaces/IUserInterface";
import { useUser } from "../../../context/UserContext";

export function useUserData() {
  const { call, ready } = useApiClient();
  const { user: contextUser } = useUser();
  const [data, setData] = useState<ILoggedUser | null>(contextUser);
  const [loading, setLoading] = useState(!contextUser);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!ready || contextUser) return;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await call<ILoggedUser>(getLoggedUser);
        setData(result);
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    })();
  }, [ready, contextUser]);

  return { data: contextUser || data, loading, error };
}
